module.exports = __webpack_public_path__ + "assets/images/template/image-background-header.jpg?v=56ceba06";